// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchResult_wrapper__c1eoN"};